import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import useStateCallback from "../../util/customHooks/useStateCallback";
import UpdateStationOwnerModal from "./UpdateStationOwnerModal"; // Updated modal component
import ajaxStationOwners from "../../util/remote/ajaxStationOwners";
import { useFilter } from "../../Context/FilterContext";
import PageHeader from "../Structure/PageHeader";
import RegisterStationaryOwnerModal from "./RegisterStationaryOwnerModal";
const ViewFuelStationOwners = () => {
  const { filterVisible, toggleFilter } = useFilter();
  const itemsPerPageOptions = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [ownersList, setOwnersList] = useState([]);
  const [meta, setMeta] = useState([]);
  const [page, setPage] = useState(1);
  const [viewType, setViewType] = useState("table view");
  const [search, setSearch] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // Fetch Station Owners
  const fetchOwners = async () => {
    setLoading(true);
    const data = {
      page,
      items_per_page: itemsPerPage,
      search: search || null,
    };
    const response = await ajaxStationOwners.liststation_owners(data);
    if (response.status === "OK") {
      setOwnersList(response.details.list || []);
      setMeta(response.details.meta?.list_of_pages || []);
    } else {
      toast.error(response.message || "Failed to fetch owners");
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchOwners();
  }, [page, search, itemsPerPage]);
  const toggleView = (type) => setViewType(type);
  const [update, setUpdate] = useStateCallback(false);
  const handleViewDetails = (owner) => {
    setUpdate(false, () =>
      setUpdate(<UpdateStationOwnerModal data={owner} func={fetchOwners} />)
    );
  };
  const [Registers, setRegisters] = useStateCallback(false);
  const handleRegister = () => {
    setRegisters(false, () =>
      setRegisters(<RegisterStationaryOwnerModal func={fetchOwners} />)
    );
  };
  const setNextPageNumber = () => page < meta.length && setPage(page + 1);
  const setPreviousPageNumber = () => page > 1 && setPage(page - 1);
  const setPageNumber = (e, item) => {
    e.preventDefault();
    setPage(item);
  };
  const filteredActions = [
    {
      label: "card view",
      icon: "fa-regular fa-address-card",
      className: "btn btn-primary btn-sm",
      onClick: () => toggleView("card view"),
    },
    {
      label: "table view",
      icon: "fa-solid fa-table",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("table view"),
    },
    {
      label: "Filter",
      icon: "fe fe-filter",
      className: "btn btn-secondary btn-sm ",
      onClick: () => toggleFilter(),
    },
    {
      label: "Register owner",
      icon: "fa-solid fa-file-pen",
      className: "btn ripple btn-primary btn-sm",
      onClick: () => handleRegister(),
    },
  ].filter((action) => action.label !== viewType);
  return (
    <AppContainer
      title="Station Owners"
      previousPageTitle="Dashboard"
      actions={filteredActions}
    >
      <div className="container-fluid">
        <Toaster />
        {update}
        {Registers}
        {/* Top Controls */}
        <div className="row align-items-center mb-4"></div>
        {filterVisible && (
          <div className="row">
            <div className="col-sm-12 col-lg-12 col-xl-12">
              <div className="card shadow-sm border-0 rounded-3">
                <div className="card-body p-4">
                  <div className="bg-light p-3 rounded-3 border mb-3">
                    <div className="row g-3 align-items-end">
                      {/* Items per page */}
                      <div className="col-lg-2">
                        <label className="form-label fw-semibold">
                          Items per page
                        </label>
                        <Select
                          value={itemsPerPageOptions.find(
                            (opt) => opt.value === itemsPerPage
                          )}
                          onChange={(selected) => {
                            setPage(1);
                            setItemsPerPage(selected.value);
                          }}
                          options={itemsPerPageOptions}
                          isSearchable={false}
                          classNamePrefix="react-select"
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              minHeight: "35px",
                              height: "35px",
                              fontSize: "0.875rem",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "4px",
                            }),
                            clearIndicator: (provided) => ({
                              ...provided,
                              padding: "4px",
                            }),
                          }}
                        />
                      </div>
                      {/* Search */}
                      <div className="col-lg-3">
                        <label className="form-label fw-semibold">Search</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search owners..."
                          value={search}
                          onChange={(e) => {
                            setPage(1);
                            setSearch(e.target.value);
                          }}
                        />
                      </div>
                      {/* Buttons */}
                      <div className="col-lg-7 d-flex justify-content-end gap-2">
                        <button
                          className="btn btn-primary btn-sm m-2"
                          onClick={fetchOwners}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Loading / No Data */}
        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">
            Loading owners...
          </div>
        ) : ownersList.length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">
            No owners found
          </div>
        ) : viewType === "table view" ? (
          <>
            <div className="row">
              <div className="col-sm-12 col-xl-12 col-lg-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="card-title mb-1">Fuel Station Owners</h6>
                      <p className="text-muted card-sub-title">
                        tabulation of fuel station owners
                      </p>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Owner Names</th>
                            <th>Contact</th>
                            <th>Alt Contact</th>
                            <th>Email</th>
                            <th>Address</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ownersList.map((owner, index) => (
                            <tr key={owner.id}>
                              <td>{(page - 1) * itemsPerPage + index + 1}</td>
                              <td>{owner.station_owner_names}</td>
                              <td>{owner.contact}</td>
                              <td>{owner.contact2}</td>
                              <td>{owner.email}</td>
                              <td>{owner.address}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    owner.status === "1"
                                      ? "bg-success"
                                      : "bg-danger"
                                  }`}
                                >
                                  {owner.status === "1" ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td>
                                <button
                                  className="btn btn-sm btn-info"
                                  onClick={() => handleViewDetails(owner)}
                                >
                                  <i className="fe fe-edit-2"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="row">
              <div className="col-sm-12 col-xl-12 col-lg-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="card-title mb-1">Fuel Station Owners</h6>
                      <p className="text-muted card-sub-title">
                        tabulation of fuel station owners
                      </p>
                    </div>
                    <div className="row">
                      {ownersList.map((owner) => (
                        <div className="col-md-4 col-lg-3 mb-3" key={owner.id}>
                          <div
                            className="card h-100"
                            style={{
                              borderRadius: "12px",
                              boxShadow: "4px 4px 12px rgba(0,0,0,0.1)",
                            }}
                          >
                            <div className="card-body text-center">
                              <h6 className="mb-1">
                                {owner.station_owner_names}
                              </h6>
                              <p className="text-muted mb-1">{owner.address}</p>
                              <small className="d-block">{owner.contact}</small>
                              <small className="d-block">
                                {owner.contact2}
                              </small>
                              <small className="d-block text-muted">
                                {owner.email}
                              </small>
                              <small className="d-block text-muted">
                                Company ID: {owner.company_id}
                              </small>
                              <div className="mt-2">
                                <span
                                  className={`badge px-3 py-1 ${
                                    owner.status === "1"
                                      ? "bg-success"
                                      : "bg-danger"
                                  }`}
                                >
                                  {owner.status === "1" ? "Active" : "Inactive"}
                                </span>
                              </div>
                              <div className="d-flex justify-content-center mt-3">
                                <button
                                  className="btn btn-sm btn-outline-primary px-3"
                                  onClick={() => handleViewDetails(owner)}
                                >
                                  <i className="fe fe-edit-2"></i>Edit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* Pagination */}
        <div className="card-footer ">
          <nav className="d-flex justify-content-center">
            <ul className="pagination mb-0">
              <li className="page-item">
                <button className="page-link" onClick={setPreviousPageNumber}>
                  Prev
                </button>
              </li>
              {Array.isArray(meta) &&
                meta.map((item) =>
                  page === item ? (
                    <li className="page-item active" key={item}>
                      <span className="page-link">{item}</span>
                    </li>
                  ) : (
                    <li className="page-item" key={item}>
                      <a
                        className="page-link"
                        href="#"
                        onClick={(e) => setPageNumber(e, item)}
                      >
                        {item}
                      </a>
                    </li>
                  )
                )}
              <li className="page-item">
                <button className="page-link" onClick={setNextPageNumber}>
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </AppContainer>
  );
};
export default ViewFuelStationOwners;
